import React from "react";
import { Helmet } from "react-helmet";
import Layout from "../components/structure/Layout";
import ContactForm from "../components/forms/ContactForm";
import HeroContact from "../components/heros/HeroContact";

function Contact() {
  return (
    <div className="page-contact">
      <Helmet>
        <html lang="en" />
        <title>Fantastic Fish Company | Contact</title>
        <meta name="description" content="Contact Us" />
      </Helmet>
      <Layout>
        <HeroContact />
        <main id="main-content" tabIndex="-1">
          <ContactForm />
        </main>
      </Layout>
    </div>
  );
}

export default Contact;
